
import {useLocation} from "react-router-dom";

function AAA() {
  let location = useLocation();
  let payUrl = location.state.promoInfo.pay_url;
  //console.log("AAA url "+ payUrl);
  window.location.replace(payUrl);

  return (
    <>
     
    </>
  );
}

export default AAA;